
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  ref,
  watch,
} from 'vue';

interface IListBrand {
  code: number;
  name: string;
  billingUnits: string[];
  checked: boolean;
}

export default defineComponent({
  components: {},

  props: {
    brandFilter: {
      type: Object as PropType<IListBrand[]>,
      default: () => ({}),
    },
  },

  setup(props, { emit }) {
    const propsRef = ref(props);
    const selectedValue = ref(props.brandFilter);
    const filterBrands = computed(() => propsRef.value.brandFilter);

    watch(propsRef.value, (newValue) => {
      selectedValue.value = newValue.brandFilter;
      emit('filter-tag', selectedValue.value);

      if (newValue.brandFilter.every((el) => el.checked === true))
        allBrands.value = true;
      else allBrands.value = false;
    });

    const changeFilter = (brand) => {
      emit('value-selected', brand);
      emit('filter-tag', selectedValue.value);
      if (selectedValue.value.every((el) => el.checked === true)) {
        allBrands.value = true;
        return;
      }
      allBrands.value = false;
    };

    onMounted(() => (selectedValue.value = filterBrands.value));

    const allBrands = ref(true);

    const changeAllBrands = () => {
      if (!allBrands.value) {
        selectedValue.value = props.brandFilter.map((el) => {
          return { ...el, checked: false };
        });
        // selectedValue.value.map((brand) => emit('value-selected', brand));
        emit('all-filter', { filterName: 'brand', checked: false });

        return;
      }
      selectedValue.value = props.brandFilter.map((el) => {
        return { ...el, checked: true };
      });
      // selectedValue.value.map((unit) => emit('value-selected', unit));
      emit('filter-tag', selectedValue.value);
      emit('all-filter', { filterName: 'brand', checked: true });
    };

    const eventStop = (e) => {
      e.stopPropagation();
    };

    return {
      selectedValue,
      emit,
      filterBrands,
      changeFilter,
      eventStop,
      changeAllBrands,
      allBrands,
    };
  },
});
